import { HttpClient } from '@sdir/httpclient/lib/HttpClient';

import {
  CourseApi,
  CourseCodeApi,
  CourseEducationApi,
  InstitutionCourseApi,
  EducatiaApi,
} from '@sdir/httpclient/lib/clients/aps/course';

import {
  ApplicationSeagoingApi,
  OccupationRegisterApi,
  SeagoingServicesApi,
  SeagoingTimeCalculatorApi,
  SeagoingRegistrationApi,
} from '@sdir/httpclient/lib/clients/aps/seagoing';

import { InternalApi as DispensationApi } from '@sdir/httpclient/lib/clients/aps/dispensation';
import { AssessmentApi } from '@sdir/httpclient/lib/clients/aps/assessor';

import {
  AdditionalCompetenceApiApi,
  AdditionalCompetenceCodesApi,
} from '@sdir/httpclient/lib/clients/aps/additionalcompetence';

import { GetVesselApi } from '@sdir/httpclient/lib/clients/core/vessel';

import { InternalApi as EndorsementApi } from '@sdir/httpclient/lib/clients/aps/endorsement';

import {
  PersonalCertificateApi,
  CertificateApi,
  SharedCompetenceApi as PersonalCertificateSharedCompetenceApi,
  SeafarerIdentityDocumentApi as SidCertificateApi,
} from '@sdir/httpclient/lib/clients/aps/personalcertificate';

import {
  SearchApiApi,
  CountryApi,
  VesselApi,
  OrganizationApi,
  PersonApi,
} from '@sdir/httpclient/lib/clients/core/search';

import {
  ContactInfoApi,
  AttachmentApi as AddresseeAttachmentApi,
  CodeElementsApi,
  PersonApi as CommonPersonApi,
} from '@sdir/httpclient/lib/clients/core/commonaddressee';

import {
  QualificationsApi,
  CreateApplicationApi,
  GetApi,
  AttachmentApi as ApplicationAttachmentApi,
  ConfirmDraftApi,
  UpdateApplicationApi,
  PaymentApi,
  OverRuleApi,
  SeagoingApi,
  CalculateExpiryApi,
  SeafarerIdentityDocumentApi,
  QualificationConfirmationApi,
} from '@sdir/httpclient/lib/clients/aps/application';

import { FregApi } from '@sdir/httpclient/lib/clients/core/externallookup';

import {
  HealthCheckApi,
  SharedCompetenceApi as HealthSharedCompetenceApi,
  MedicalCertificateApi,
} from '@sdir/httpclient/lib/clients/aps/health';
import { DEFAULT_LANG, getCurrentLanguageOutsideProvider } from '../helpers/languageHelpers';

const clientId = 'mss';
const authority = process.env.REACT_APP_EXTERNALAUTHURL || '';
const baseUrl = process.env.REACT_APP_API_URL;
const httpClient = new HttpClient(baseUrl);

httpClient.addAPIMSubscriptionKeyHeader(process.env.REACT_APP_SUBSCRIPTIONKEY);
httpClient.addOICDAuthorizationHeader(authority, clientId);
httpClient.addRequestMiddleware((req) => {
  const currentLang = getCurrentLanguageOutsideProvider();
  req.headers = {
    ...req.headers,
    'Accept-Language': req.headers?.['Accept-Language'] || currentLang || DEFAULT_LANG,
  };
  return req;
});

export const courseApi = new CourseApi(
  undefined,
  `${baseUrl}/aps-course-internal`,
  httpClient.client
);

export const courseCodeApi = new CourseCodeApi(
  undefined,
  `${baseUrl}/aps-course-internal`,
  httpClient.client
);

export const occupationRegisterApi = new OccupationRegisterApi(
  undefined,
  `${baseUrl}/aps-seagoing-internal`,
  httpClient.client
);

export const seagoingTimeCalculatorApi = new SeagoingTimeCalculatorApi(
  undefined,
  `${baseUrl}/aps-seagoing-internal`,
  httpClient.client
);

export const seagoingServicesApi = new SeagoingServicesApi(
  undefined,
  `${baseUrl}/aps-seagoing-internal`,
  httpClient.client
);

export const searchApiApi = new SearchApiApi(
  undefined,
  `${baseUrl}/core-search-internal`,
  httpClient.client
);

export const countryApi = new CountryApi(
  undefined,
  `${baseUrl}/core-search-internal`,
  httpClient.client
);

export const organizationApi = new OrganizationApi(
  undefined,
  `${baseUrl}/core-search-internal`,
  httpClient.client
);

export const vesselApi = new VesselApi(
  undefined,
  `${baseUrl}/core-search-internal`,
  httpClient.client
);

export const getVesselApi = new GetVesselApi(
  undefined,
  `${baseUrl}/core-vessel-internal`,
  httpClient.client
);

export const endorsementApi = new EndorsementApi(
  undefined,
  `${baseUrl}/aps-endorsement-internal`,
  httpClient.client
);

export const courseEducationApi = new CourseEducationApi(
  undefined,
  `${baseUrl}/aps-course-internal`,
  httpClient.client
);

export const personalCertificateApi = new PersonalCertificateApi(
  undefined,
  `${baseUrl}/aps-personalcertificate-internal`,
  httpClient.client
);

export const personalCertificateSharedCompetenceApi = new PersonalCertificateSharedCompetenceApi(
  undefined,
  `${baseUrl}/aps-personalcertificate-internal`,
  httpClient.client
);

export const certificateApi = new CertificateApi(
  undefined,
  `${baseUrl}/aps-personalcertificate-internal`,
  httpClient.client
);

export const sidCertificateApi = new SidCertificateApi(
  undefined,
  `${baseUrl}/aps-personalcertificate-internal`,
  httpClient.client
);

export const dispensationApi = new DispensationApi(
  undefined,
  `${baseUrl}/aps-dispensation-internal`,
  httpClient.client
);

export const assessmentApi = new AssessmentApi(
  undefined,
  `${baseUrl}/aps-assessor-internal`,
  httpClient.client
);

export const additionalCompetenceApi = new AdditionalCompetenceApiApi(
  undefined,
  `${baseUrl}/aps-additionalcompetence-internal`,
  httpClient.client
);

export const qualificationsApi = new QualificationsApi(
  undefined,
  `${baseUrl}/aps-application-internal`,
  httpClient.client
);

export const createApplicationApi = new CreateApplicationApi(
  undefined,
  `${baseUrl}/aps-application-internal`,
  httpClient.client
);

export const sidApplicationApi = new SeafarerIdentityDocumentApi(
  undefined,
  `${baseUrl}/aps-application-internal`,
  httpClient.client
);

export const confirmationApi = new QualificationConfirmationApi(
  undefined,
  `${baseUrl}/aps-application-internal`,
  httpClient.client
);

export const confirmDraftApi = new ConfirmDraftApi(
  undefined,
  `${baseUrl}/aps-application-internal`,
  httpClient.client
);

export const paymentApi = new PaymentApi(
  undefined,
  `${baseUrl}/aps-application-internal`,
  httpClient.client
);

export const applicationAttachmentApi = new ApplicationAttachmentApi(
  undefined,
  `${baseUrl}/aps-application-internal`,
  httpClient.client
);

export const addresseeAttachmentApi = new AddresseeAttachmentApi(
  undefined,
  `${baseUrl}/core-commonaddressee-internal`,
  httpClient.client
);

export const getApplicationApi = new GetApi(
  undefined,
  `${baseUrl}/aps-application-internal`,
  httpClient.client
);

export const getHealthStatusApi = new HealthCheckApi(
  undefined,
  `${baseUrl}/aps-health-internal`,
  httpClient.client
);

export const healthSharedCompetenceApi = new HealthSharedCompetenceApi(
  undefined,
  `${baseUrl}/aps-health-internal`,
  httpClient.client
);

export const medicalExaminationApi = new MedicalCertificateApi(
  undefined,
  `${baseUrl}/aps-health-internal`,
  httpClient.client
);

export const contactInfoApi = new ContactInfoApi(
  undefined,
  `${baseUrl}/core-commonaddressee-internal`,
  httpClient.client
);

export const commonAddresseePersonApi = new CommonPersonApi(
  undefined,
  `${baseUrl}/core-commonaddressee-internal`,
  httpClient.client
);

export const personApi = new PersonApi(
  undefined,
  `${baseUrl}/core-search-internal`,
  httpClient.client
);

export const codeElementsApi = new CodeElementsApi(
  undefined,
  `${baseUrl}/core-commonaddressee-internal`,
  httpClient.client
);

export const institutionCourseApi = new InstitutionCourseApi(
  undefined,
  `${baseUrl}/aps-course-internal`,
  httpClient.client
);

export const educatiaApi = new EducatiaApi(
  undefined,
  `${baseUrl}/aps-course-internal`,
  httpClient.client
);

export const updateApplicationApi = new UpdateApplicationApi(
  undefined,
  `${baseUrl}/aps-application-internal`,
  httpClient.client
);

export const fregApi = new FregApi(
  undefined,
  `${baseUrl}/core-externallookup-internal`,
  httpClient.client
);

export const additionalCompetenceCodesApi = new AdditionalCompetenceCodesApi(
  undefined,
  `${baseUrl}/aps-additionalcompetence-external`,
  httpClient.client
);

export const overruleApi = new OverRuleApi(
  undefined,
  `${baseUrl}/aps-application-internal`,
  httpClient.client
);

export const calculateExpiryApi = new CalculateExpiryApi(
  undefined,
  `${baseUrl}/aps-application-internal`,
  httpClient.client
);

export const seagoingApi = new SeagoingApi(
  undefined,
  `${baseUrl}/aps-application-internal`,
  httpClient.client
);

export const applicationSeagoingApi = new ApplicationSeagoingApi(
  undefined,
  `${baseUrl}/aps-seagoing-internal`,
  httpClient.client
);

export const seagoingRegistrationApi = new SeagoingRegistrationApi(
  undefined,
  `${baseUrl}/aps-seagoing-internal`,
  httpClient.client
);
